import { render } from "./SwapCardContent.vue?vue&type=template&id=d0a1aa94&scoped=true"
import script from "./SwapCardContent.vue?vue&type=script&lang=js"
export * from "./SwapCardContent.vue?vue&type=script&lang=js"

import "./SwapCardContent.vue?vue&type=style&index=0&id=d0a1aa94&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0a1aa94"],['__file',"src/components/SwapCardContent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d0a1aa94"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d0a1aa94', __exports__)) {
    api.reload('d0a1aa94', __exports__)
  }
  
  module.hot.accept("./SwapCardContent.vue?vue&type=template&id=d0a1aa94&scoped=true", () => {
    api.rerender('d0a1aa94', render)
  })

}


export default __exports__